import styled from 'styled-components';
import breakpoints from '../breakpoints';

export const CrossPromoContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: ${props => (props.margin || '0 40px')};
    width: 100%;

    &:last-child {
        margin-bottom: 0;
    }

    @media ${breakpoints.large} {
        flex-direction: row;
        justify-content: space-evenly;
        max-width: 1280px;
    }
`;
